var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageHeader',{attrs:{"title":"Collections","text":"Bientôt disponibles"}})
}
var staticRenderFns = []

export { render, staticRenderFns }